const MMMs = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export default {
  mmmDdYyyy: d => `${MMMs[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`
}
